import { lazy } from 'react';
const ManualShiftCreation = lazy(() => import('./ManualShiftCreation'));

const ManualShiftCreationRoutes = [
  {
    path: '/hrsystem/manualShiftCreation',
    component: ManualShiftCreation
  }
];

export default ManualShiftCreationRoutes;
